import axios from "axios";
import Cookies from "js-cookie";

const refreshAccessToken = async () => {
  try {
    const refreshToken = Cookies.get("refresh_token");
    const refreshResponse = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/token/refresh`,
      {
        refresh_token: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Update access token
    const newAccessToken = refreshResponse.data.access_token;
    const sevenDaysFromNow = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000); // 7 days in milliseconds

    // Set the access_token cookie with expiration date
    // Set the access_token cookie with expiration date
    Cookies.set("access_token", newAccessToken, {
      expires: sevenDaysFromNow,
      secure: true,
      sameSite: "Strict",
    });
  } catch (refreshErr) {
    console.log("Failed to refresh token:", refreshErr);
    // Logout user
    localStorage.setItem("user", null);
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    window.location.href = "/sign-in";

    return;
  }
};

export default refreshAccessToken;
